import type supplierId from "./id";

const supplierEn: typeof supplierId = {
	supplier: {
		title: "Supplier",
		subtitle: "Manage ingredient and product suppliers",
		table: {
			title: "Supplier Data",
			columns: {
				name: "Supplier Name",
				pic: "PIC",
				phone: "PIC Phone Number",
				email: "Email",
				address: "Address",
				status: "Status",
				action: "Action",
			},
			empty_state: {
				title: "No suppliers yet",
				description: "Add a supplier to start recording stock purchases.",
			},
		},
		filters: {
			status: "Status",
			all_statuses: "All Statuses",
		},
		status: {
			active: "Active",
			inactive: "Inactive",
		},
		form: {
			add_title: "Add Supplier",
			edit_title: "Edit Supplier",
			name: "Supplier Name",
			pic: "PIC",
			phone: "PIC Phone Number",
			email: "Email",
			address: "Address",
			status: "Status",
			submit: "Save",
			cancel: "Cancel",
			add_success: "Supplier added",
			edit_success: "Supplier updated",
			errors: {
				name_required: "Supplier name is required",
				email_invalid: "Invalid email format",
			},
		},
		delete: {
			title: "Delete Supplier",
			description: "A deleted supplier cannot be restored. Delete anyway?",
			confirm: "Delete",
			cancel: "Cancel",
			success: "Supplier deleted",
		},
	},
};

export default supplierEn;
